import { BACKEND_URL as FLOW_API_BACKEND_URL } from "src/api/endpoints";
import { BACKEND_URL as TAKTILE_API_BACKEND_URL } from "src/api/taktileApi";

export const isTaktileRequest = (url: string) => {
  try {
    return (
      url.startsWith(TAKTILE_API_BACKEND_URL) ||
      url.startsWith(FLOW_API_BACKEND_URL) ||
      new URL(url).hostname.endsWith("taktile.com") ||
      new URL(url).hostname.endsWith("tktl.io")
    );
  } catch {
    return false;
  }
};

const REFRESH_PATH = "/api/v1/login/refresh";

export const ENTITY_ANALYTICS_PATH = "/entities/api/v1/analytics";

// `useCopilotPrewarm` swallows every ping failure, and with `keepAlive` it
// retries on a timer, so a 403 here leaves the user nothing to act on.
const COPILOT_V0_PREWARM_PING_PATH = "/copilots/management/api/v0/ping";
const COPILOT_V2_PREWARM_PING_PATH = "/copilot/api/v2/ping";

const FIRE_AND_FORGET_PATHS = [
  ENTITY_ANALYTICS_PATH,
  COPILOT_V0_PREWARM_PING_PATH,
  COPILOT_V2_PREWARM_PING_PATH,
] as const;

export const isFireAndForgetRequest = (url: string | undefined): boolean => {
  if (!url) {
    return false;
  }
  try {
    const pathname = new URL(url, window.location.origin).pathname;
    return FIRE_AND_FORGET_PATHS.some((path) => pathname.endsWith(path));
  } catch {
    return false;
  }
};

// Path-only match: the scoped refresh URL carries query params.
export const isRefreshUrl = (url: string): boolean => {
  try {
    return new URL(url, window.location.origin).pathname.endsWith(REFRESH_PATH);
  } catch {
    return false;
  }
};
